import React, { useEffect, useState, useRef } from "react";
import classes from "../../style/Style.module.css";
import "../../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DexterCall from "../../Images/UpdatedDexter-call.svg";
import {
  Address_Verification,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_DXTER_SCANNING,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
} from "../../Routes";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import statesList from "../../Components/StateList";
import { useSelector } from "react-redux";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectPanNumber } from "../../Store/panNumberSlice";
import axios from "../../libs/axiosConfig";
import {
  ROUTE_PLACEOF_BIRTH,
  ROUTE_EMAIL,
  ROUTE_NOMINEE_DETAILS,
  ROUTE_ACCOUNT_TYPE,
  ROUTE_OCCUPATION,
  Gender_Dob_Verification,
  ROUTE_CHECKBOXES,
  ROUTE_NOMINEE_SENDOTP, ROUTE_NRI_Address
} from "../../Routes";
import { useDispatch } from "react-redux";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import LogoutModal from "../../Components/LogoutModal";
import {
  selectAddressLine1,
  selectAddressLine2,
  selectAddressLine3,
} from "../../Store/addressSlice";
import {
  selectCity,
  selectCountry,
  selectState,
  selectZip,
} from "../../Store/stateSlice";

const StatePincode = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState("");
  const [country, setCountry] = useState("INDIA");
  const [pincode, setPincode] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const Navigate = useNavigate();
  const [suggestionsState, setSuggestionsState] = useState([]);
  const [showSuggestionsState, setShowSuggestionsState] = useState(false);
  const dropdownRef = useRef(null);
  const [SuggestionsCountry, setSuggestionsCountry] = useState(false);
  const [showSuggestionsCountry, setShowSuggestionsCountry] = useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const [showModal, setShowModal] = useState(false);

  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [isLoading, setIsLoading] = useState(false);
  const NriAddressLine = useSelector(selectAddressLine1);
  const NriAddressLine2 = useSelector(selectAddressLine2);
  const NriAddressLine3 = useSelector(selectAddressLine3);
  const NriZipCode = useSelector(selectZip);
  const NriState = useSelector(selectState);
  const NriselectCountry = useSelector(selectCountry);
  const NriselectCity = useSelector(selectCity);

  console.log(NriZipCode, NriState, NriselectCountry, NriselectCity, "Collect");
  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowSuggestionsState(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fullAddressFromPreviousScreen = useSelector(
    (state) => state.dexterrPortfolio.fullAddress
  );
  // console.log(fullAddressFromPreviousScreen);
  const refreshToken = useSelector(selectRefreshToken);
  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  // const countriesList = [{ name: "INDIA", code: "IND" }];

  // const handleCountryListShow = () => {
  //   if (showSuggestionsCountry) {
  //     setSuggestionsCountry([]);
  //     setShowSuggestionsCountry(false);
  //   } else {
  //     const countryNames = countriesList.map((country) => country.name);
  //     setSuggestionsCountry(countryNames);
  //     setShowSuggestionsCountry(countryNames.length > 0);
  //   }
  // };

  const handleCountrySuggestionClick = (selectedCountry) => {
    console.log("Selected Country:", selectedCountry);
    setCountry(selectedCountry);
    setSuggestionsCountry([]);
    setShowSuggestionsCountry(false);
  };
  const handlestatelistShow = () => {
    if (showSuggestionsState) {
      setSuggestionsState([]);
      setShowSuggestionsState(false);
    } else {
      const stateNames = statesList.map((state) => state.name);
      setSuggestionsState(stateNames);
      setShowSuggestionsState((prevShowSuggestions) => !prevShowSuggestions);
    }
  };

  const handleSuggestionClick = (selectedState) => {
    const selectedStateObject = statesList.find(
      (state) => state.name === selectedState
    );
    if (selectedStateObject) {
      console.log("Selected State Code:", selectedStateObject.code);
    }
    setState(selectedState);
    setSuggestionsState([]);
    setShowSuggestionsState((prevShowSuggestions) => !prevShowSuggestions);
  };

  const handleClearButtonClick = (field) => {
    if (field === "state") {
      setState("");
    } else if (field === "pincode") {
      setPincode("");
    }
    setFormErrors({});
  };
  // const handleCountryChange = (e) => {
  //   const inputValue = e.target.value;
  //   setCountry(inputValue);

  //   const filteredSuggestions = countriesList.filter((country) =>
  //     country.name.toLowerCase().includes(inputValue.toLowerCase())
  //   );

  //   setSuggestionsCountry(filteredSuggestions.map((country) => country.name));
  //   setShowSuggestionsCountry(true);
  // };

  const validateState = (input) => {
    const regex = /^[a-zA-Z0-9\s]+$/;
    return regex.test(input);
  };

  const validatePincode = (input) => {
    const regex = /^[0-9]+$/;
    return regex.test(input);
  };

  const handleStateChange = (e) => {
    const inputValue = e.target.value;
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      setState(inputValue);
      setFormErrors({ ...formErrors, state: "" });
    } else {
      if (validateState(inputValue)) {
        setState(inputValue);
        const filteredSuggestions = statesList
          .filter((state) =>
            state.name.toLowerCase().startsWith(inputValue.toLowerCase())
          )
          .slice(0, 5);
        setSuggestionsState(filteredSuggestions.map((state) => state.name));
        setShowSuggestionsState(filteredSuggestions.length > 0);
        setFormErrors({ ...formErrors, state: "" });
        setFormErrors({ ...formErrors, pincode: "" });
      } else {
        setFormErrors({
          ...formErrors,
          state: "Only alphabets and numbers are allowed",
        });
        setSuggestionsState([]);
        setShowSuggestionsState(false);
      }
    }
  };

  const handlePincodeChange = (e) => {
    const inputValue = e.target.value;
    if (validatePincode(inputValue)) {
      setPincode(inputValue);
      console.log("Entered Pincode:", inputValue);
      setFormErrors({ ...formErrors, pincode: "" });
      setFormErrors({ ...formErrors, state: "" });
    } else {
      if (inputValue === "") {
        setPincode("");
        setFormErrors({ ...formErrors, pincode: "" });
      } else {
        setFormErrors({ ...formErrors, pincode: "Only numbers are allowed" });
      }
    }
  };

  const handleSubmit = async () => {
    // if (state && pincode) {
    //   toast.success("Form submitted successfully");
    //   // Navigate(ROUTE_DEPOSITE_MONEY);
    // } else {
    //   toast.error("Please fill all the required details");
    // }

    if (!state && !pincode) {
      toast.error("Please fill all the required details");
      setApiCallsInProgress(apiCallsInProgress - 1);
    }

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      setApiCallsInProgress(apiCallsInProgress + 1);

      // Find the selected state object
      const selectedStateObject = statesList.find(
        (stateObj) => stateObj.name === state
      );
      if (!selectedStateObject) {
        throw new Error("Selected state not found in the state list");
      }

      const fullAddressValue = `${fullAddressFromPreviousScreen} ${pincode} ${state} ${country}`;
      const NriFullAddressValue = `${NriAddressLine}"-"${NriAddressLine2}"-"${NriAddressLine3}"-"${NriZipCode}"-"${NriState}"-"${NriselectCountry}"-"${NriselectCity}`;

      const isIndianResident = country === "INDIA";

      const firstapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const nriAddressDetails = {
        nseNriAddressLine1: NriAddressLine,
        nseNriAddressLine2: NriAddressLine2,
        nseNriAddressLine3: NriAddressLine3,
        nseNriZip: NriZipCode,
        nseNriCity: NriselectCity,
        nseNriState: NriState,
        nseNriCountry: NriselectCity,
        nseNriFullAddress: NriFullAddressValue,
      };

      const customerKycDetails = {
        request_type: "post",
        mobileNumber: phoneNumber,
        pan: panNumber,
        zip: pincode,
        fullAddress: fullAddressValue,
        nseStateCode: selectedStateObject.code,
        nseStateDescription: state,
        country: "INDIA",
        state: state,
      };

      if (!isIndianResident) {
        Object.assign(customerKycDetails, nriAddressDetails);
      }

      const requestBody = { CustomerKycDetails: customerKycDetails };

      const response = await axios.post(firstapi, requestBody, { headers });
      console.log("First API Response:", response.data);

      // const secondapi =
      //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails";
      // const secondRequestBody = {
      //   zip: pincode,
      //   nseStateCode: selectedStateObject.code,
      //   nseStateDescription: state,
      //   fullAddress: fullAddressValue,
      //   country: "INDIA",
      //   state: state,
      // };

      // if (!isIndianResident) {
      //   Object.assign(secondRequestBody, nriAddressDetails);
      // }

      // const secondResponse = await axios.post(secondapi, secondRequestBody, {
      //   headers,
      // });
      // console.log("Second API Response:", secondResponse.data);

      if (response.data.statusCode === 200) {
        const thirdapi =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
        const thirdRequestBody = {
          CustomerKycDetails: {
            request_type: "get",
            mobileNumber: phoneNumber,
            pan: panNumber,
          },
        };
        // setApiCallsInProgress(apiCallsInProgress - 1);

        const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
          headers,
        });
        // const customerKycApiResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );

        if (
          thirdResponse.data.statusCode === 200 &&
          thirdResponse.data.status === true
        ) {
          setApiCallsInProgress(apiCallsInProgress - 1);

          if (thirdResponse.data.body.emailId === "") {
            Navigate(ROUTE_EMAIL);
          } else if (
            thirdResponse.data.body.bankAccountNumber === "" ||
            thirdResponse.data.body.bankIfscCode === "" ||
            thirdResponse.data.body.bankAccountType === "" ||
            thirdResponse.data.body.bankName === "" ||
            thirdResponse.data.body.bankBranchName === "" ||
            thirdResponse.data.body.bankBranchAddress === "" ||
            thirdResponse.data.body.bankCodeNSE === "" ||
            thirdResponse.data.body.bankCodeBillDesk === "" ||
            thirdResponse.data.body.bankAccountHolderName === ""
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            (thirdResponse.data.body.bankAccountNumber !== "" ||
              thirdResponse.data.body.bankIfscCode !== "" ||
              thirdResponse.data.body.bankAccountType !== "" ||
              thirdResponse.data.body.bankName !== "" ||
              thirdResponse.data.body.bankBranchName !== "" ||
              thirdResponse.data.body.bankBranchAddress !== "" ||
              thirdResponse.data.body.bankCodeNSE !== "" ||
              thirdResponse.data.body.bankCodeBillDesk !== "" ||
              thirdResponse.data.body.bankAccountHolderName !== "" ||
              null) &&
            (thirdResponse.data.body.bankVerified.account_exists !== "True" ||
              thirdResponse.data.body.bankVerified.message !== "success")
          ) {
            Navigate(ROUTE_ACCOUNT_TYPE);
          } else if (
            thirdResponse.data.body.panDetails.addr1 === "" ||
            thirdResponse.data.body.panDetails.addr2 === "" ||
            thirdResponse.data.body.panDetails.city === "" ||
            thirdResponse.data.body.panDetails.state === "" ||
            thirdResponse.data.body.panDetails.pincode === "" ||
            thirdResponse.data.body.panDetails.country === "" ||
            thirdResponse.data.body.panDetails.fullAddress === ""
          ) {
            Navigate(Address_Verification);
          } else if (
            thirdResponse.data.body.placeOfBirth === "" ||
            thirdResponse.data.body.nseCountryCodeOfBirth === "" ||
            thirdResponse.data.body.nseCountryOfBirth === ""
          ) {
            Navigate(ROUTE_PLACEOF_BIRTH);
          } else if (
            thirdResponse.data.body.politicallyExposedPerson === "" ||
            null ||
            thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""
          ) {
            Navigate(ROUTE_CHECKBOXES);
          } else if (
            (thirdResponse.data.body.nomineeName !== "" &&
              thirdResponse.data.body.nomineeType !== "" &&
              thirdResponse.data.body.nomineeRelationShip !== "" &&
              thirdResponse.data.body.nomineeDob !== ""
            ) &&
            (thirdResponse.data.body.nomineeVerified === "N"
            )
          ) {
            console.log(thirdResponse.data.body.nomineeName, thirdResponse.data.body.nomineeType, thirdResponse.data.body.nomineeRelationShip
              , thirdResponse.data.body.nomineeDob, thirdResponse.data.body.nomineeVerified)
            // console.log("first");
            Navigate(ROUTE_NOMINEE_SENDOTP);
          }
          else {
            const requestBody = {
              dexterrCustomerBasicQuestions: {
                mobile_no: phoneNumber,
                request_type: "get",
                country_code: "+91",
              }
            };
            const headers = {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken
            };

            const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
              headers: headers
            });
            if (secondApiResponse.data.data.resident !== "Resident Indian") {
              Navigate(ROUTE_NRI_Address)
            }
            else {
              Navigate(ROUTE_DXTER_SCANNING);
            }
          }


        } else {
          Toast.error(
            thirdResponse.data.message + " " + thirdResponse.data.errorMessage
          );
        }
        setApiCallsInProgress(apiCallsInProgress - 1);
      } else {
        setApiCallsInProgress(apiCallsInProgress - 1);
      }
      setApiCallsInProgress(apiCallsInProgress + 1);

      // Navigate(ROUTE_PLACEOF_BIRTH);
    } catch (error) {
      console.error("Error submitting data:", error);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
    }
  };

  return (
    <div className="Pincode_Main_Container">
      <div className="Pincode_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="Pincode_Container">
        <p className="Input_Heading_text">What's your State? </p>

        <div className="Pincode_Filed_Box">
          <span className="Enter_pincode_text">Enter Your State</span>
          <div className="pincode_input_container" ref={dropdownRef}>
            <input
              className={`${classes.Input_Filed} ${formErrors.state ? classes.Error : ""
                }`}
              value={state}
              onChange={handleStateChange}
            />
            <button
              className={classes.DropDown_button}
              onClick={handlestatelistShow}
            />
            {showSuggestionsState && (
              <div className={classes.Suggestions_Container}>
                {suggestionsState.map((suggestion, index) => (
                  <div
                    key={index}
                    className={classes.Suggest_Suggestion}
                    onClick={() => handleSuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {formErrors.state && (
          <span className={classes.Error_Message}>{formErrors.state}</span>
        )}

        <div className="Pincode2_Filed_Box">
          <span className="Enter_pincode2_text">Enter your pin code</span>
          <div className="pincode2_Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.pincode ? classes.Error : ""
                }`}
              value={pincode}
              onChange={handlePincodeChange}
              placeholder="eg :313001"
              maxLength={6}
            />

            <button
              className={classes.Cross_button}
              onClick={() => handleClearButtonClick("pincode")}
            />
          </div>
        </div>
        {formErrors.pincode && (
          <span className={classes.Error_Message}>{formErrors.pincode}</span>
        )}

        <div className="Pincode3_Filed_Box">
          <span className="Enter_pincode3_text">Enter Your Country</span>
          <div className="pincode3_Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.country ? classes.Error : ""
                }`}
              value={country}
              readOnly
            // onChange={handleCountryChange}
            />
            {/* <button
              className={classes.DropDown_button}
              onClick={handleCountryListShow}
            /> */}
            {showSuggestionsCountry && (
              <div className={classes.Suggestions_Container}>
                {SuggestionsCountry.map((suggestion, index) => (
                  <div
                    key={index}
                    className={classes.Suggest_Suggestion}
                    onClick={() => handleCountrySuggestionClick(suggestion)}
                  >
                    {suggestion}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {formErrors.country && (
          <span className={classes.Error_Message}>{formErrors.country}</span>
        )}
        <button className="Submit_button" onClick={handleSubmit}>
          {" "}
          Submit{" "}
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default StatePincode;
